<template>
	<div class="m-coupon flex">
		<ul class="flex">
			<li v-for="(item, i) in list" :key="i" class="flex">
				<div class="flex-center flex-grow flex-column">
					<p class="sum">￥<strong>30</strong></p>
					<p class="limit">满100可用</p>
				</div>
				<div class="button flex-center">领<br>取</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: new Array(3)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-coupon {
		padding: 12px;
		
		ul {
			float: left;
			
			li {
				width: 124px;
				height: 44px;
				background-image: url('~@/submodule/assets/image/decorate/app_u_coupon.png');
				background-size: 100% 100%;
				
				&:nth-child(n+2) {
					margin-left: 7px;
				}
				
				.sum {
					margin-bottom: 5px;
					font-size: 13px;
					font-weight: bold;
					
					strong {
						font-size: 18px;
					}
				}
				
				.limit {
					font-size: 12px;
					color: #574800;
				}
				
				.button {
					width: 40px;
					line-height: 18px;
					font-size: 13px;
				}
			}
		}
	}
</style>
